import { render } from "./BaseCalendar.vue?vue&type=template&id=46a3f230"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__